import { MoveEventsCargoOperation } from '../types/ViewModel/MoveEventsCargoOperation';

export class MoveEventsCargoOperationFactory {
    constructor() {}

    public createMoveEventsCargoOperationItem(fromCargoOperationId: number, toCargoOperationId: number): MoveEventsCargoOperation {
        return new MoveEventsCargoOperation(fromCargoOperationId, toCargoOperationId);
    }

    public createMoveEventsCargoOperationBM(moveEventsCargoOperation: MoveEventsCargoOperation): any {
        return {
            fromCargoOperationId: moveEventsCargoOperation.fromCargoOperationId,
            toCargoOperationId: moveEventsCargoOperation.toCargoOperationId,
        };
    }
}
